module.exports = __webpack_public_path__ + "media/images/game/yourchance-4ff9ce4190e007e982342dd80e6be5fa.png";